export default __webpack_public_path__ + "static/media/plain-sticker-i.78f6bee3.png";